import ReactEchartsCore from "echarts-for-react/lib/core";
import * as echarts from "echarts/core";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import {
  BrushComponent,
  DatasetComponent,
  DataZoomComponent,
  DataZoomInsideComponent,
  DataZoomSliderComponent,
  GridComponent,
  GridSimpleComponent,
  LegendComponent,
  MarkLineComponent,
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  VisualMapComponent,
  VisualMapContinuousComponent,
  VisualMapPiecewiseComponent,
} from "echarts/components";
import { BarChart } from "echarts/charts";
import "moment/locale/tr";
import { GaugeChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";
import { LineChart } from "echarts/charts";
import ImkbEndeksSenetler, { SentimentEndeksLabel } from "../../ata/imkb";
import {
  query,
  collection,
  orderBy,
  limit,
  getDocs,
  where,
} from "firebase/firestore";
import React from "react";
import { fireStore } from "../../../../firebase";
moment.locale("tr");

echarts.use([
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  DataZoomComponent,
  DatasetComponent,
  DataZoomSliderComponent,
  GridSimpleComponent,
  DataZoomInsideComponent,
  VisualMapComponent,
  VisualMapContinuousComponent,
  VisualMapPiecewiseComponent,
  BrushComponent,
  LegendComponent,
  MarkLineComponent,
  CanvasRenderer,
  LineChart,
  GaugeChart,
  BarChart,
]);

export const StockLine = (props: any) => {
  const echartsRef = useRef(null);
  const updateCallbacRef = useRef<((newBar: any) => void) | null>(null);
  const updater = (symbol: any, resol: any, updateCallback: any) => {
    updateCallbacRef.current = updateCallback;
  };
  const [options, setOptions] = useState<any>(null);
  const [data, setData] = useState<any>(null);
  const [markers, setMarkers] = useState<any>(null);
  const [lastSentiment, setLastSentiment] = useState<any>(null);
  const [lastPrice, setlastPrice] = useState<any>(null);

  const getChartOptions = (forceMarkers?: any) => {
    if (!data) return;
    return {
      grid: {
        top: 20,
        bottom: 20,
        left: 40,
        right: 30,
      },
      tooltip: {
        trigger: "axis",
        axisPointer: { type: "cross", crossStyle: { color: "#999" } },
      },

      legend: {
        data: [
          // "OTT"
        ],
        textStyle: {
          color: "#ddd",
        },
      },
      xAxis: [
        {
          show: false,
          type: "category",
          data: data.DateList,
          axisPointer: { type: "shadow" },
          axisLabel: { formatter: "" },
        },
      ],
      yAxis: [
        {
          position: "left",
          type: "value",
          name: "",
          min: 0,
          max: 10,
          interval: 1,
          splitLine: {
            show: false
          },
          axisLabel: {
            color: "#ddd",
          },
        },
        {
          position: "right",
          type: "value",
          name: "",
          scale: true,
          splitLine: {
            show: true,
            lineStyle: {
              color: "#242b3e",
            },
          },
          axisLabel: {
            color: "#ddd",
          },
        },
        // {
        //     position: 'left',
        //     type: 'value',
        //     name: '',
        //     scale: true
        // },
      ],
      series: [
        {
          name: "Sentiment Puanı",
          type: "line",
          data: data.SentimentList,
          yAxisIndex: 0,
          symbolSize: 4,
          lineStyle: {
            normal: {
              width: 3,
              color: "#1d9afb",
            },
          },
        },
        {
          name: "Fiyat",
          type: "line",
          data: data.PriceList,
          yAxisIndex: 1,
          symbolSize: 3,
          lineStyle: {
            normal: {
              width: 3,
              color: "#3dad4a",
            },
          },
        },
        {
          name: "STP",
          type: "line",
          data: data.VWMA,
          yAxisIndex: 1,
          symbolSize: 0,
          lineStyle: {
            normal: {
              width: 3,
              color: "#fcba03",
              // shadowColor: '#000',
              // shadowBlur: 30
            },
          },
        },
        // {
        //     name: "OTT",
        //     type: 'line',
        //     data: data.OTT,
        //     yAxisIndex: 1,
        //     symbolSize: 0,
        //     lineStyle: {
        //         normal: {
        //             width: 3,
        //             color: "#fcba03",
        //             // shadowColor: '#000',
        //             // shadowBlur: 30
        //         }
        //     }
        // }
      ],
    };
  };
  const markerFormatter = (value: any) => {
    return parseFloat(value.value).toFixed(2);
  };
  const updateMarkers = () => {
    const newMarkers: any = [];
    if (lastSentiment) {
      newMarkers.push({
        name: "destek",
        yAxis: lastSentiment.value[1],
        lineStyle: {
          width: 0,
        },
        label: {
          formatter: markerFormatter,
          backgroundColor: "#2266f9",
        },
      });
    }
    if (props.marker1 != null && props.marker1 !== "")
      newMarkers.push({
        name: "destek",
        yAxis: props.marker1,
        label: {
          formatter: markerFormatter,
        },
      });
    if (props.marker2 != null && props.marker2 !== "")
      newMarkers.push({
        name: "destek",
        yAxis: props.marker2,
        label: {
          formatter: markerFormatter,
        },
      });
    if (props.marker3 != null && props.marker3 !== "")
      newMarkers.push({
        name: "destek",
        yAxis: props.marker3,
        label: {
          formatter: markerFormatter,
        },
      });
    if (props.marker4 != null && props.marker4 !== "")
      newMarkers.push({
        name: "destek",
        yAxis: props.marker4,
        label: {
          formatter: markerFormatter,
        },
      });

    setMarkers(newMarkers);
    setOptions(getChartOptions());
    setTimeout(() => {
      const echartCurrent: any = echartsRef.current;

      if (echartCurrent) {
        echartCurrent
          .getEchartsInstance()
          .setOption(getChartOptions(newMarkers), true);
      }
    }, 100);
  };
  useEffect(() => {
    updateMarkers();
  }, [
    props.marker1,
    props.marker2,
    props.marker3,
    props.marker4,
    lastSentiment,
  ]);
  useEffect(() => {
    const q = query(
      collection(fireStore, "NS_LINES_1W_P4"),
      orderBy("date", "desc"),
      limit(1)
    );

    getDocs(q).then((querySnapshot: any) => {
      if (querySnapshot.docs.length == 0) return;
      const doc = querySnapshot.docs[0];
      const entry = (doc.data()[`lines0${props.list}`] ?? []).find(
        (x: any) => x.symbol === props.symbol
      );
      if (!entry) return;

      const entryDate = moment(entry.date, "DD.MM.YYYY HH:mm");

      const chartData = {
        name: "lines30",
        Index: entry.index,
        Symbol: entry.symbol,
        Sentiment: entry.sentiment,
        Order: entry.order,
        ODate: entry.openDate ?? entry.ltp?.openDate,
        OPrice: entry.openPrice && entry.openPrice != "0" ? entry.openPrice : "",
        Price: entry.price,
        DailyChange: entry.dailyChange,
        Vbts: entry.vbts,
        First5to10: entry.first5to10,
        IsNewFirst5: entry.isNewFirst5,
        Viop: entry.viop,
        PerDay: entry.perDay,
        SentimentList: entry.sentimentList,
        PriceList: entry.priceList,
        ChangeList: entry.changeList,
        ReChangeList: entry.changeList?.slice().reverse(),
        dateTime: entryDate.toDate(),
        Time: entry.time ?? 0,
        UpdateTime: entryDate.format("DD.MM.yy HH:mm"),
        LineDate: entryDate.unix(),
        Indexes: ImkbEndeksSenetler.filter(
          (x) => x.name == entry.symbol
        )?.[0]?.val,

        OTT: entry.ott,
        Directions: entry.directions,
        VWMA: entry.vwma?.slice().reverse(),
      };
      setData(chartData);
      setOptions(getChartOptions());
    });
  }, []);
  if (!data) return null;

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        backgroundColor: "rgb(19,23,35)",
        borderRadius: 5,
      }}
    >
      <div style={{ color: "#fff", textAlign: "center", padding: 3 }}>
        {data?.Symbol}
      </div>

      <div
        className={
          "weekly-chart-order " +
          (data.Order <= 10 ? "weekly-order-green" : "weekly-order-black")
        }
      >
        {data.Order}
      </div>
      <ReactEchartsCore
        echarts={echarts}
        ref={echartsRef}
        style={{
          height: `${props.height}px`,
          width: "100%",
          marginBottom: 0,
          backgroundColor: "rgb(19,23,35)",
        }}
        option={options ?? getChartOptions()}
      />
    </div>
  );
};
